const $ = require('jquery');
const optiExperiment = require('../optimizelyExperimentation');

/**
 * Show the default cart subtitle or the modify one.
 *
 * @param {boolean} isTreatment3 -
 */
function showCartSubtitle(isTreatment3) {
    if (isTreatment3) {
        $('.cart-subtitle')[0].classList.remove('initially-hidden');
    } else {
        $('.cart-subtitle')[1].classList.remove('initially-hidden');
    }
}
/**
 * Init the track events for the checkout buttons.
 *
 * @param {boolean} isTreatment1Active -
 */
function initTrackEvents(isTreatment1Active) {
    if (!isTreatment1Active) {
        $('.cart-action-checkout')[0].addEventListener('click', function () {
            optiExperiment.trackEvent('proceed_to_checkout_click');
            window.sessionStorage.setItem('isCOReachedWithOptiStickyButton', '1');
        });
    }

    $('.cart-action-checkout')[1].addEventListener('click', function () {
        optiExperiment.trackEvent('proceed_to_checkout_click');
        window.sessionStorage.setItem('isCOReachedWithOptiStickyButton', '1');
    });
}

/**
 * Prevent button to start the CO, instead it scroll the page to the original button.
 */
function initClikAndScrollEvent() {
    const elementBoundingTop = $('.cart-action-checkout')[1].getBoundingClientRect().top;
    const scrollY = elementBoundingTop + window.scrollY - window.innerHeight * 0.6;
    $('.cart-action-checkout')[0].addEventListener('click', function (event) {
        $('#continueCheckoutSticky').css('background-color', '#023f85');
        $('#continueCheckoutSticky').css('color', '#ffffff');
        event.preventDefault();
        window.scroll(0, scrollY);
        optiExperiment.trackEvent('proceed_to_checkout_click_2');
    });
}

/**
 * Initiallize the scroll event to hide or show the sticky button.
 */
function initScrollEvent() {
    const proceedToCOButtonSticky = $('.cart-action-checkout')[0];
    const proceedToCOButton = $('.cart-action-checkout')[1];

    $(window).on('scroll', function () {
        const proccedButtonBounds = proceedToCOButton.getBoundingClientRect();
        const isVisibleC0Button = proccedButtonBounds.top - window.innerHeight + proccedButtonBounds.height < 0;

        if (isVisibleC0Button) {
            proceedToCOButton.style.visibility = 'visible';
            proceedToCOButtonSticky.style.display = 'none';
        } else {
            proceedToCOButton.style.visibility = 'hidden';
            proceedToCOButtonSticky.style.display = 'block';
        }
    });
}

module.exports = {
    /**
     * init optimizely experimentation for cart
     */
    async init() {
        const util = require('../../utils/util');
        const result = await optiExperiment.decideFeatureFlagVariation('cart');
        const isCartStickyFlagEnabled = $('.cart-actions').length
            ? $('.cart-actions')[0].dataset.isCartStickyFlagEnabled
            : '';

        if (
            result.variationKeyStickyProceedCheckout !== 'off' &&
            isCartStickyFlagEnabled === 'true' &&
            util.isMobile()
        ) {
            $('.sticky-button-container')[0].classList.remove('initially-hidden');
            initScrollEvent();
            const isTreatment1 = result.variationKeyStickyProceedCheckout === 'treatment_1';
            if (isTreatment1) {
                initClikAndScrollEvent();
            }

            showCartSubtitle(result.variationKeyStickyProceedCheckout === 'treatment_2');
            initTrackEvents(isTreatment1);
        }
    }
};
